export enum ApplicationStage {
  PHONE_SCREEN = 'PHONE_SCREEN',
  SUBMITTED = 'SUBMITTED',
  INTERVIEW = 'INTERVIEW',
  OFFER_EXTENDED = 'OFFER_EXTENDED',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  HIRED = 'HIRED',
  REJECTED = 'REJECTED',
  NO_STAGE = 'NO_STAGE'
}
